import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_MARKETING_OPERACOES: MapaCargo = 
{
  id: 'analista-de-marketing-operacoes',
  titulo: 'Analista de Marketing - Operações',
  setor: 'Operações',
  secoes: [
    {
      id: 'atualizacao-de-plataformas-digitais',
      titulo: 'Atualização de plataformas digitais',
      atividades: [
        'Garantir que websites e landing pages estejam atualizados com conteúdo e design adequados.',
        'Realizar ajustes e otimizações em sistemas de e-commerce, CRM e outras ferramentas digitais.',
      ],
    },
    {
      id: 'gestao-de-ferramentas-de-marketing',
      titulo: 'Gestão de ferramentas de marketing',
      atividades: [
        'Operar ferramentas de automação de marketing, como RD Station, HubSpot ou similares.',
        'Operar campanhas de e-mail marketing.',
      ],
    },
    {
      id: 'gestao-de-anuncios-pagos-ppc',
      titulo: 'Gestão de anúncios pagos (PPC)',
      atividades: [
        'Auxiliar na criação e manutenção de campanhas em Google Ads, Facebook Ads, LinkedIn Ads, entre outros.',
      ],
    },
    {
      id: 'criacao-de-materiais-de-apoio',
      titulo: 'Criação de materiais de apoio',
      atividades: [
        'Redação de materiais diversos, legendas e copys.',
        'Auxiliar em apresentações, propostas e materiais institucionais para clientes.',
        'Apoiar time de criação na produção de materiais gráficos, como artes digitais e outros.',
      ],
    },
    {
      id: 'planejamento-estrategico',
      titulo: 'Planejamento estratégico',
      atividades: [
        'Colaborar na execução de planos de marketing e cronogramas.',
        'Apoiar o time de criação e estratégia na concepção de novas campanhas.',
      ],
    },
    {
      id: 'atendimento-ao-cliente',
      titulo: 'Atendimento ao cliente',
      atividades: [
        'Servir de ponto de contato entre clientes e a equipe da agência.',
        'Reunir feedbacks e acompanhar aprovações e revisões.',
        'Dar andamento e apoiar equipe nas solicitações do cliente.',
      ],
    },
  ],
}
